@if (!selectedCategory && !digitalizationSelected) {
  <div>
    <h1 class="page-title">General Emissions</h1>
    <div class="grid-container">
      @for (category of categories; track category) {
        <app-card
          [title]="category.text.text_en"
          class="category-card"
          >
          <div class="category-header">
            <div class="progress-container">
              <app-progress-bar
                [progress]="getProgressForCategory(category.id)"
                [color]="getProgressColor(category.id)"
                />
              <span class="progress-counter">
                {{ getAnsweredCount(category.id) }}/{{ getTotalCount(category.id) }}
                Questions
              </span>
            </div>
          </div>
          <div class="category-action">
            <button class="btn" (click)="onCategoryClick(category)">
              {{ getCategoryButtonLabel(category.id) }}
            </button>
          </div>
        </app-card>
      }
      <!-- Separate category from the baseline categories 'digitalization' because it is structured differently -->
      <app-card title="Digitalization" class="category-card">
        <div class="category-header">
          <!-- TODO: Add logic for tracking digitalization logic -->
          <div class="progress-container">
            <app-progress-bar [progress]="getDigitalizationProgress()" [color]="getProgressColor(0)" />
            <span class="progress-counter"> {{ getDigitalizationAnsweredCount() }}/1 Questions </span>
          </div>
          <div class="category-action">
            <button class="btn" (click)="onDigitalizationSelectedToggle()">
              {{hasDigitalizationEntries() ? 'Edit' : 'Start'}} questionnaire
            </button>
          </div>
        </div>
      </app-card>
    </div>
    @if (baselineConstants) {
      <div class="single-app-card">
        <app-card title="CO₂ Baseline">
          <div class="baseline-content">
            <p class="baseline-description">
              These values represent the CO₂ emissions that are standard for everyone living in Switzerland.
              You cannot change these numbers as they apply to all individuals, regardless of personal behavior.
              They include:
            </p>
            <div class="baseline-items">
              @for (constant of baselineConstants; track constant) {
                <div class="baseline-item">
                  <div class="baseline-item-info">
                    <p class="baseline-item-title">{{ constant.text.text_en }}</p>
                    <mat-icon
                      class="info-icon"
                      [matTooltip]='constant.remarksText.text_en'
                      matTooltipPosition="above"
                      matTooltipTouchGestures="on"
                      #tooltip="matTooltip"
                      (click)="tooltip.toggle()"
                    >info</mat-icon>
                  </div>
                  <span class="baseline-item-value">~ {{ constant.causedEmissions.toFixed(0) }} kg CO₂</span>
                </div>
              }
            </div>
          </div>
        </app-card>
      </div>
    }
  </div>
}

@if (selectedCategory) {
  <div>
    <h1 class="page-title">{{ selectedCategory.text.text_en }}</h1>
    <button class="btn" (click)="onBackToOverview()"><app-icon name="arrow_left"/>Back to overview</button>
    <app-baseline-category
      [categoryName]="selectedCategory.text.text_en"
      [questions]="getQuestionsForCategory(selectedCategory.id)"
      [userEntries]="userBaselineEntries"
      (answerChanged)="onBaselineAnswerChanged()"
    ></app-baseline-category>
  </div>
}

@if (!selectedCategory && digitalizationSelected) {
  <div>
    <h1 class="page-title">Digitalization</h1>
    <button class="btn" (click)="onDigitalizationSelectedToggle()"><app-icon name="arrow_left"/>Back to overview</button>
    <app-digitalization
      [userEntries]="userProductEntries"
      [products]="products"
    (answerChanged)="onDigitalizationAnswerChanged()"></app-digitalization>
  </div>
}
